import {blue, red, purple, indigo, lightBlue, green, yellow, orange} from '@mui/material/colors';

export const gatewayUrl = "https://" + window.location.host
export const authorization = "https://" + window.location.host
export const logout = "https://" + window.location.host + "/logout/oauth"
export const webSocketPath = "wss://" + window.location.host

/** Organization for Kuhni Verso customer self-registration. */
export const KUHNI_CUSTOMER_REGISTRATION_ORGANIZATION = "Алфексгрупп";

const getAuthorizationRegistrationOrigin = () => {
    const baseUrl = process.env.REACT_APP_AUTHORIZATION_BASE_URL;
    if (baseUrl) {
        try {
            return new URL(baseUrl).origin;
        } catch {
            /* ignore invalid env */
        }
    }
    return "https://authorization.upme.by";
};

export const buildCustomerRegistrationUrl = (
    organizationName = KUHNI_CUSTOMER_REGISTRATION_ORGANIZATION,
) =>
    `${getAuthorizationRegistrationOrigin()}/user-registration?organizationName=${encodeURIComponent(organizationName)}&customer=true`;

export const authorizationServicesPath = `${gatewayUrl}${process.env.REACT_APP_AUTHORIZATION}${process.env.REACT_APP_API_VERSION_AUTHORIZATION}`
export const ordersServicesPath = `${gatewayUrl}${process.env.REACT_APP_ORDERS}${process.env.REACT_APP_API_VERSION_ORDERS}`
export const materialCloudServicesPath = `${gatewayUrl}${process.env.REACT_APP_MATERIAL_CLOUD}${process.env.REACT_APP_API_VERSION_MATERIAL_CLOUD}`
export const detailServicesPath = `${gatewayUrl}${process.env.REACT_APP_DETAIL}${process.env.REACT_APP_API_VERSION_DETAIL}`
export const estimateServicesPath = `${gatewayUrl}${process.env.REACT_APP_ESTIMATE}${process.env.REACT_APP_API_VERSION_ESTIMATE}`
export const cuttingServicesPath = `${gatewayUrl}${process.env.REACT_APP_CUTTING}${process.env.REACT_APP_VERSION_CUTTING}`
export const utilityServicesPath = `${gatewayUrl}${process.env.REACT_APP_UTILITY}${process.env.REACT_APP_API_VERSION_UTILITY}`
export const threeDConverterServicesPath = `${gatewayUrl}${process.env.REACT_APP_THREE_D_CONVERTER}${process.env.REACT_APP_API_VERSION_THREE_D_CONVERTER}`

export const authorizedOrganization = ['ROLE_ORGANIZATION_USER', 'ROLE_ORGANIZATION_SUPER_USER']
export const authorizedAdmin = ['ROLE_ADMIN', 'SYSTEM_ADMIN']

export const fullAccessRolesOrganization = ["ROLE_ORGANIZATION_SUPER_USER", "ROLE_ORGANIZATION_CREATOR"]

export const offerWaitingTime = 60 //minutes
export const constantsOfInputValues = {
    MAX_LENGTH: 2800,
    MAX_WIDTH: 2070
}
export const constantsErrorMessages = {
    401: "доступ запрещён",
    403: "доступ запрещён",
    404: "нет связи с сервером"
}
export const COLORS = {
    "1": red,
    "2": purple,
    "3": indigo,
    "4": lightBlue,
    "5": green,
    "6": yellow,
    "7": orange
}

export const SIDE = [
    {
        value: 'TOP',
        label: 'Верхняя грань',
    },
    {
        value: 'BOTTOM',
        label: 'Нижняя грань',
    },
    {
        value: 'FRONT',
        label: 'Передний торец',
    },
    {
        value: 'BACK',
        label: 'Задний торец',
    },
    {
        value: 'LEFT',
        label: ' Левый торец',
    },
    {
        value: 'RIGHT',
        label: 'Правый торец',
    },
]
